<m-expansion-panel *ngIf="contadorHistoricoConsulta > 0" [id]="'hisConsulta-consultaSerasa'"
  [title]="'Consultas à Serasa - Lock&Unlock ('+contadorHistoricoConsulta+')'" [active]="larguraEhSuperiorMin">
  <div *ngIf="contadorHistoricoConsulta > 0" class="table-responsive" id="div-table-hisConsulta-consultaSerasa">
    <table id="id-table-hisConsulta-consultaSerasa" class="table table-striped table-borderless" aria-label="Tabela de Consultas à Serasa - Lock&Unlock" style="font-size: smaller;">
      <thead>
        <tr>
          <th scope="col">Empresa</th>
          <th scope="col">Data da consulta</th>
          <th scope="col">CNPJ</th>
          <th scope="col">Quantidade de consultas</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let passagem of historicoConsulta.passagens; index as i">
          <td>{{ passagem.empresa | naoinformado }}</td>
          <td>{{ passagem.data | naoinformado }}</td>
          <td>{{ passagem.cnpj | naoinformado }}</td>
          <td>{{ passagem.quantidadeConsultas | naoinformado }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div id="id-div-hisConsulta-falha"
    *ngIf="listaServicoFalha.includes('hist-consulta-passagem') || contadorHistoricoConsulta == 0">
    {{historicoConsulta.falhaServico.message}}
  </div>

  <app-alert [id]="'hisConsulta-mensagem'" [tipo]="'info'" >
    Esse relatório disponibiliza as tentativas de consultas realizadas por terceiros durante o período em que você utilizou a ferramenta Lock&Unlock e seu Serasa Score esteve bloqueado.
  </app-alert>

</m-expansion-panel>
